export default {
  layout: {
    contentPadding: '20px',
    containerMargin: '20px',
    rowSpacing: '10px',
    inputGroupSpacing: '10px',
    labelWidth: '348px',
    labelMarginRight: '20px',
    inputWidth: '348px',
    buttonWidth: '100px',
    buttonHeight: '32px',
    wideButtonWidth: '150px',
    extraWideButtonWidth: '200px',
    
    cardMarginLeft: '20px',
    cardMarginRight: '20px',
    cardMinWidth: '600px',
    cardMaxWidth: 'none',
    cardWidth: 'calc(100vw - 320px)',
  },

  colors: {
    primary: '#0078d4',
    error: '#d32f2f',
    success: '#388e3c',
    warning: '#f57c00',
    text: '#000000ff',
    background: '#f5f5f5',
    cardBackground: '#fff',
    border: '#ddd'
  },

  typography: {
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: {
      small: '12px',
      normal: '14px',
      medium: '16px',
      large: '18px',
      xlarge: '24px'
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 700
    }
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  }
};
